import React from 'react';

import { useTranslations } from 'next-intl';
import styled from 'styled-components';

import { useFilter as useFilterHook } from '../hooks/useFilter';
import { useMaterialsTableContext } from '../MaterialsTableContext';
import messages from './messages';

/**
 * @todo theme - colors
 * @todo hover effect
 */
const FilterButton = styled.div<{ $active: boolean }>`
  display: flex;
  height: 2.25rem;
  padding: 0 15px;
  justify-content: center;
  align-items: center;
  gap: 0.625rem;
  border-radius: 0.125rem;
  border: 1px solid
    ${({ theme, $active }) =>
      $active ? theme.custom.colors.brand : theme.custom.colors.gray200};
  outline: ${({ $active, theme }) =>
    $active ? `1px solid ${theme.custom.colors.brand}` : 'none'};
  background: ${({ $active }) => ($active ? '#ffeee8' : '#fff')};
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
`;

interface FilterItemProps {
  filter: string;
}

/**
 * @todo translate
 */
export default function FilterItem({ filter }: FilterItemProps) {
  const { selectedFilters, setSelectedFilters } = useMaterialsTableContext();
  const translate = useTranslations();

  const useFilter = useFilterHook({
    selectedFilters,
    setSelectedFilters,
  });

  const onClickAction = React.useCallback(() => {
    if (filter === 'ALL') {
      if (selectedFilters.length > 0) {
        setSelectedFilters([]);
      }
    } else {
      if (selectedFilters.includes(filter)) {
        useFilter.remove(filter);
      } else {
        useFilter.add(filter);
      }
    }
  }, [selectedFilters, filter, useFilter]);

  const isActive = React.useMemo(
    () =>
      filter === 'ALL'
        ? selectedFilters.length === 0
        : selectedFilters.includes(filter),
    [selectedFilters, filter]
  );

  const camelCased = filter
    .toLowerCase()
    .replace(/_([a-z])/g, g => g[1].toUpperCase());

  return (
    <FilterButton onClick={onClickAction} $active={isActive}>
      {translate(messages[camelCased]) || filter}
    </FilterButton>
  );
}
